<template>
	<div class="cs_faq card">
		<h3 class="title">{{ $t('merchant.menu_2.menu4') }}</h3>
		<div class="faq">
			<accordion v-for="item in faqList" :key="item.seq" class="faq cs">
				<accordion-item>
					<template v-slot:accordion-trigger>
						<p class="question mb_0">{{ item.title }}</p>
						<span class="accordion_trigger_icon"></span>
					</template>

					<template v-slot:accordion-content>
						<p class="answer mb_0" v-html="item.content"></p>
					</template>
				</accordion-item>
			</accordion>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import { fetchFaqList } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Faq',
	components: {
		Accordion,
		AccordionItem,
		pagination,
	},
	data() {
		return {
			faqList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadFaqList();
		},
		async loadFaqList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.faqList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadFaqList();
		},
	},
};
</script>
